import React, { useState } from 'react';
import { contactEmail } from '../utils/email';

function SupportForm() {
  const [app, setApp] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailAddress = contactEmail();
    const subject = encodeURIComponent(`Support Request - ${app}`);
    const body = encodeURIComponent(
      `App: ${app}\nUser Email: ${userEmail}\n\nMessage:\n${message}`
    );
    window.location.href = `mailto:${emailAddress}?subject=${subject}&body=${body}`;
  };

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes blink {
          0%, 60% { opacity: 1; }
          61%, 100% { opacity: 0; }
        }
        .cursor {
          animation: blink 1.1s step-end infinite;
        }
      `}</style>
      <nav style={styles.nav}>
        <a href="/" style={styles.logoLink} aria-label="Go to DDHAPPS home">
          <span style={styles.logo}>
          <span style={styles.logoDDH}>DDH</span>
          <span style={styles.logoBracket}>[</span>
          <span style={styles.logoApps}>APPS</span>
          <span style={styles.logoBracket}>]</span>
          <span className="cursor" style={styles.logoCursor}>_</span>
          </span>
        </a>
        <a href="/" style={styles.navLink}>Back to home</a>
      </nav>

      <main style={styles.main}>
        <section style={styles.hero}>
          <p style={styles.eyebrow}>Support</p>
          <h1 style={styles.title}>How can we help?</h1>
          <p style={styles.subtitle}>
            Send us a quick message and we will get back to you as soon as possible.
          </p>
        </section>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>
            Select Your App
          <select
            value={app}
            onChange={(e) => setApp(e.target.value)}
            required
            style={styles.input}
          >
            <option value="">--Please choose an app--</option>
            <option value="RiddleMe">RiddleMe</option>
          </select>
        </label>

        <label style={styles.label}>
          Your Email
          <input
            type="email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            required
            placeholder="your.email@example.com"
            style={styles.input}
          />
        </label>

        <label style={styles.label}>
          Your Message
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            placeholder="Describe your issue or feedback here..."
            rows={5}
            style={styles.textarea}
          />
        </label>

        <button type="submit" style={styles.button}>
          Send Email
        </button>
        </form>
      </main>
    </div>
  );
}

const MONO = "'SF Mono', 'Fira Code', 'Fira Mono', 'Consolas', 'Menlo', monospace";
const SANS = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f9f9f7',
    color: '#2a2a2a',
    fontFamily: SANS,
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 32px',
    borderBottom: '1px solid #ebebeb',
    background: '#f9f9f7',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  logo: {
    fontFamily: MONO,
    fontSize: '0.9rem',
    fontWeight: 600,
    letterSpacing: '0.03em',
    userSelect: 'none',
  },
  logoLink: {
    textDecoration: 'none',
  },
  logoDDH: { color: '#2a2a2a' },
  logoBracket: { color: '#9ca3af' },
  logoApps: { color: '#555' },
  logoCursor: { color: '#9ca3af', fontFamily: MONO },
  navLink: {
    fontSize: '0.85rem',
    fontWeight: 500,
    color: '#555',
    textDecoration: 'none',
    padding: '7px 16px',
    border: '1px solid #ddd',
    borderRadius: 8,
  },
  main: {
    maxWidth: 760,
    margin: '0 auto',
    padding: 'clamp(28px, 6vw, 56px) 24px 72px',
  },
  hero: {
    textAlign: 'center',
    marginBottom: 28,
  },
  eyebrow: {
    fontFamily: MONO,
    fontSize: '0.78rem',
    fontWeight: 500,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#9ca3af',
    margin: '0 0 12px',
  },
  title: {
    fontSize: 'clamp(2rem, 6vw, 3rem)',
    fontWeight: 800,
    letterSpacing: '-0.03em',
    lineHeight: 1.1,
    color: '#1c1c1e',
    margin: '0 0 12px',
  },
  subtitle: {
    fontSize: '0.95rem',
    color: '#6b6b6b',
    lineHeight: 1.7,
    margin: 0,
  },
  form: {
    background: '#fff',
    border: '1px solid #ebebeb',
    borderRadius: 18,
    padding: '22px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
  },
  label: {
    display: 'block',
    fontSize: '0.82rem',
    fontWeight: 600,
    color: '#4b5563',
    marginBottom: 14,
  },
  input: {
    display: 'block',
    width: '100%',
    padding: '11px 12px',
    marginTop: 8,
    marginBottom: 0,
    border: '1px solid #d1d5db',
    borderRadius: 10,
    background: '#fcfcfb',
    color: '#1f2937',
    fontSize: '0.93rem',
    fontFamily: SANS,
    boxSizing: 'border-box',
  },
  textarea: {
    display: 'block',
    width: '100%',
    padding: '11px 12px',
    marginTop: 8,
    marginBottom: 0,
    border: '1px solid #d1d5db',
    borderRadius: 10,
    background: '#fcfcfb',
    color: '#1f2937',
    fontSize: '0.93rem',
    fontFamily: SANS,
    resize: 'vertical',
    boxSizing: 'border-box',
  },
  button: {
    marginTop: 6,
    display: 'inline-block',
    background: '#1c1c1e',
    color: '#f9f9f7',
    border: 'none',
    textDecoration: 'none',
    fontSize: '0.88rem',
    fontWeight: 700,
    padding: '12px 18px',
    borderRadius: 10,
    letterSpacing: '0.01em',
    cursor: 'pointer',
  },
};

export default SupportForm;
